"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function HeldLicenseCreate(row) {
  var quantity = row.quantity,
    targetEntity = row.targetEntity;
  if (targetEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin added ", quantity, " license", quantity === 1 ? '' : 's', " to ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Admin added ", quantity, " license", quantity === 1 ? '' : 's', " to an unknown group", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
    type: "Group"
  }));
}
var _default = exports["default"] = HeldLicenseCreate;